import { axiosJSONInstance } from '@/config';
import { BulkActionResponse } from '@/types/order';
import {
  BulkDelayRtoPayload,
  BulkResendPayload,
  ReattemptResponse,
  ResendPayload,
  ResendResponse,
} from '@/types/inventory';

export const fetchInventoryOrders = async (page: number, perPage: number) => {
  const response = await axiosJSONInstance.get('/merchants/inventory', {
    params: { page, perpage: perPage },
  });
  return response.data;
};

export const resendOrder = async (uid: string, payload: ResendPayload): Promise<ResendResponse> => {
  const response = await axiosJSONInstance.post(`/merchants/inventory/${uid}/resend`, payload);
  return response.data;
};

export const delayRtoOrder = async (uid: string, reason?: string) => {
  const response = await axiosJSONInstance.post(`/merchants/inventory/${uid}/delay-rto`, {
    reason,
  });
  return response.data;
};

export const bulkResendOrders = async (payload: BulkResendPayload): Promise<BulkActionResponse> => {
  const response = await axiosJSONInstance.post('/merchants/inventory/bulk-resend', payload);
  return response.data;
};

export const bulkDelayRtoOrders = async (payload: BulkDelayRtoPayload) => {
  const response = await axiosJSONInstance.post('/merchants/inventory/bulk-delay-rto', payload);
  return response.data;
};

// reattemptAt is Baghdad wall-clock 'YYYY-MM-DD HH:mm' (no zone) — the backend reads it as Asia/Baghdad.
export const scheduleReattempt = async (
  uid: string,
  reattemptAt: string,
): Promise<ReattemptResponse> => {
  const response = await axiosJSONInstance.post(`/merchants/inventory/${uid}/reattempt`, {
    reattempt_at: reattemptAt,
  });
  return response.data;
};

export const fetchReattempt = async (uid: string): Promise<ReattemptResponse> => {
  const response = await axiosJSONInstance.get(`/merchants/inventory/${uid}/reattempt`);
  return response.data;
};
